import { Container, Spacer, Text, ThemeProvider } from '@sparemin/blockhead';
import React from 'react';
import { Alert } from 'components/icons';
import bem from 'utils/bem';

const block = bem('canvas-infobox');

export interface CanvasInfoboxProps {
  message: React.ReactNode | undefined;
}

const CanvasInfobox: React.FC<CanvasInfoboxProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <ThemeProvider theme="dark">
      <div className={block()}>
        <Container
          borderWeight="2px"
          cornerRadius="16px"
          gutter="24px"
          className={block('container')}
        >
          <Spacer
            orientation="horizontal"
            space="16px"
            align="center"
            justify="center"
            className={block('contents')}
          >
            <Alert
              width="24px"
              height="24px"
              fill="#fafafa"
              background="transparent"
            />

            <Text variant="label" className={block('message')}>
              {message}
            </Text>
          </Spacer>
        </Container>
      </div>
    </ThemeProvider>
  );
};

export default CanvasInfobox;
